// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dWPD","top":"styles_top__2Nh8y","left":"styles_left__2m3qE","description":"styles_description__38oCg"};